<script setup lang="ts">
    import { inject, onMounted } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { LatestIssuesAccess } from './LatestIssues.access';
    import List from '@shared/components/List.vue';
    import LatestIssueItem from './LatestIssueItem.vue';
    import { formatDateTime } from '@shared/utils/formatDateTime';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const latestIssuesAccess: LatestIssuesAccess = injectorAccess.injector.get(LatestIssuesAccess);

    onMounted(async () => {
        if (latestIssuesAccess.state.latestIssues == null) {
            await latestIssuesAccess.getLatestIssues();
        }
    });
</script>

<template>
    <List
        displayAs="table"
        itemId="WebVersionUrl"
        title="Latest Sent Mailings"
        :allLoaded="true"
        :totalItemCount="latestIssuesAccess.state.latestIssues?.length || 0"
        :externalSearchInput="true"
        :items="latestIssuesAccess.state.latestIssues"
        :loading="latestIssuesAccess.state.loading"
        :tableHeaders="['#', 'Account', 'Subject', 'From', 'Sent', 'Recipients', 'Created by', 'Actions']"
        :perPage="200"
        :orderOptions="[
            { key: 'Ended', display: 'Sent Date' }
        ]"
        :orderByValue="'Ended'"
        :orderByDirection="'desc'">
        <template #toolbar>
            <button class="btn btn-default" @click="latestIssuesAccess.getLatestIssues()">Refresh</button>
        </template>
        <template #item="{ item: issue, index }">
            <td>{{ index + 1 }}.</td>
            <td>{{ issue.AccountName }}</td>
            <td>{{ issue.Subject }}</td>
            <td>{{ issue.FromName }} &lt;{{ issue.ReplyToAddress }}&gt;</td>
            <td>{{ issue.Ended ? formatDateTime(new Date(issue.Ended)) : 'N/A' }}</td>
            <td>{{ issue.RecipientCount }}</td>
            <td>{{ issue.LastModifiedByFirstName }} {{ issue.LastModifiedByLastName }}</td>
            <td class="autofit">
                <a :href="issue.WebVersionUrl" target="_blank" class="btn btn-primary btn-sm">
                    <i class="fa fa-external-link"></i>
                    View
                </a>
            </td>
        </template>
    </List>
</template>

<style></style>

